import { Table, TableContainer, TableHead, TableRow, TableCell, Stack, TableBody, Box, Typography } from '@mui/material';
import { FC } from 'react';
import styles from '../TableView/TableView.styles';
import utils from 'utils';

const BASE_FONT_SIZE = '9px';
const BODY_CELL_PADDING_X = '8px';
const BODY_ROW_HEIGHT = '25px';
const HEADER_PADDING = '4px';

type Props = {
  data: {[key: string]: string},
  title?: string
}
const ObjectView: FC<Props> = ({ data, title }) => {

  
  return (
    <Stack
      {...utils.stack.flex.row('flex-start', 'flex-start')}
      sx={{ width: '100%' }}
    >
      <TableContainer sx={{ minWidth: '450px', width: 'auto', maxWidth: '100%' }}>
        {
          title &&
          <Box sx={{ width: '100%', background: '#333', color: 'white', padding: '6px', border: '3px solid white' }}>
            <Typography>{ title }</Typography>
          </Box>
        }
        <Table
          sx={{
            minWidth: '150px',
            fontSize: BASE_FONT_SIZE,
          }}
        >
          <TableHead>
            <TableRow>
              {
                Object.keys(data).map((header) => (
                  <TableCell
                    sx={{
                      ...styles.tableCellHeader,
                      fontSize: BASE_FONT_SIZE,
                      padding: HEADER_PADDING,
                      minWidth: '40px',
                      whiteSpace: 'nowrap',
                    }}
                    align='center'
                  >
                    { typeof header === 'object' ? '[Object]' : header.replace(/ \d+$/g, '') }
                  </TableCell>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{
                '&:last-child th': { border: 0 }
              }}
            >
              {
                Object.values(data).map((val) => (
                  <TableCell
                    sx={{
                      ...styles.tableCellValue,
                      fontSize: BASE_FONT_SIZE,
                      padding: `0 ${BODY_CELL_PADDING_X}`,
                      height: BODY_ROW_HEIGHT,
                      lineHeight: BODY_ROW_HEIGHT,
                      whiteSpace: 'nowrap',
                    }}
                    align='right'
                  >
                    { typeof val === 'object' ? '[Object]' : val }
                  </TableCell>                
                ))
              }
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default ObjectView;
